import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonalInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	className: "menu-link",
	xmlns: "http://www.w3.org/2000/svg",
	width: "30px",
	viewBox: "0 0 32 32",
	fill: "#000000",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M16.2,8.3c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5S18.1,8.3,16.2,8.3z M16.2,6.3c3,0,5.5,2.5,5.5,5.5 s-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5S13.1,6.3,16.2,6.3z M16,18.3c3.7,0,7.1,2.4,8.3,6.1c0.2,0.5-0.1,1.1-0.6,1.3 c-0.5,0.2-1.1-0.1-1.3-0.6c-1-2.8-3.5-4.7-6.4-4.7c-2.9,0-5.4,1.9-6.4,4.7c-0.2,0.5-0.7,0.8-1.3,0.6c-0.5-0.2-0.8-0.7-0.6-1.3 C8.9,20.7,12.3,18.3,16,18.3z" })]
});
const ForwardRef = forwardRef(SvgPersonalInfo);
export default ForwardRef;
